import React from 'react';

import {
  SE,
  ES,
  DK,
  GB,
  FO,
  FI,
  NO,
  NL,
  AT,
  PL,
  SK
} from 'country-flag-icons/react/3x2';

export const GetFlag = ({ countryName }) => {
  switch (countryName) {
    case 'Sweden':
      return <SE />;
    case 'Denmark':
      return <DK />;
    case 'England':
      return <GB />;
    case 'The Faroe Islands':
      return <FO />;
    case 'Finland':
      return <FI />;
    case 'Norway':
      return <NO />;
    case 'Netherlands':
      return <NL />;
    case 'Austria':
      return <AT />;
    case 'Poland':
      return <PL />;
    case 'Slovakia':
      return <SK />;
    case 'Spain':
      return <ES />;
    default:
      return <></>;
  }
};
